// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contact_wrapper__3TG4V","info":"Contact_info__31_V7","image":"Contact_image__3vktE","title":"Contact_title__C6auq"};